$(document).ready(function () {
	const isSafari = /^((?!chrome|andriod).)*safari/i.test(navigator.userAgent);
	const getAllSummary = document.querySelectorAll("summary");

	getAllSummary.forEach((item) => {
		if (isSafari) {
			// console.log("removing each icon from accordion");
			// if the browser used is safari, remove the plus minus icons
			$(item.children[1]).remove();
			$(item.children[2]).remove();
			// change the summary display from flex to block
			$(item).css("display", "block");
		}
	});

	// event delegation
	$("div.mobile-store-feature-dropdown").click(function (e) {
		if (!isSafari) {
			if (e.target.nodeName === "SUMMARY") {
				if (e.target.children[1].className === "hidden") {
					// regular text when accordian closed
					e.target.children[0].style.fontWeight = 400;
					// hide and unhide the plus & dash icon accordingly
					e.target.children[1].className = "";
					e.target.children[2].className = "hidden";
				} else {
					// bold text when accordian expand
					e.target.children[0].style.fontWeight = 700;
					// hide and unhide the plus & dash icon accordingly
					e.target.children[1].className = "hidden";
					e.target.children[2].className = "";
				}
			}
			console.log(e.target.nodeName);
			if (e.target.nodeName === "IMG" || e.target.nodeName === "H3") {
				if (e.target.parentElement.children[1].className === "hidden") {
					// regular text when accordian closed
					e.target.parentElement.children[0].style.fontWeight = 400;
					// hide and unhide the plus & dash icon accordingly
					e.target.parentElement.children[1].className = "";
					e.target.parentElement.children[2].className = "hidden";
				} else {
					// bold text when accordian expand
					e.target.parentElement.children[0].style.fontWeight = 700;
					// hide and unhide the plus & dash icon accordingly
					e.target.parentElement.children[1].className = "hidden";
					e.target.parentElement.children[2].className = "";
				}
			}
		}
	});

	// event for desktop read more
	$("div.four.tablet-above-only").on("click", function (e) {
		// console.log(e.target.nodeName, "...", e.target.className);
		if (e.target.nodeName === "SPAN" && e.target.className === "read_more") {
			$(e.target.parentElement.previousElementSibling).toggleClass("read-more-container");
			$(e.target.parentElement).children(".read_less").show();
			$(e.target.parentElement).children(".read_more").hide();
		} else {
			$(e.target.parentElement.previousElementSibling).toggleClass("read-more-container");
			$(e.target.parentElement).children(".read_more").show();
			$(e.target.parentElement).children(".read_less").hide();
			$("html,body").animate(
				{
					scrollTop: $(".text-columns-with-images-section").offset().top + 350,
				},
				"slow"
			);
		}

		if (e.target.nodeName === "IMG" && e.target.parentElement.className === "read_more") {
			$(e.target.parentElement.parentElement.previousElementSibling).toggleClass(
				"read-more-container"
			);
			$(e.target.parentElement.parentElement).children(".read_less").show();
			$(e.target.parentElement.parentElement).children(".read_more").hide();
		} else {
			$(e.target.parentElement.parentElement.previousElementSibling).toggleClass(
				"read-more-container"
			);
			$(e.target.parentElement.parentElement).children(".read_more").show();
			$(e.target.parentElement.parentElement).children(".read_less").hide();
			$("html,body").animate(
				{
					scrollTop: $(".text-columns-with-images-section").offset().top + 350,
				},
				"slow"
			);
		}
	});
});
